import { Section } from 'tio-ui/components/layout';
import { service } from '@ember/service';
import { t } from 'ember-intl';
import Component from '@glimmer/component';
import type { FinancialInstitution as FinancialInstitutionModel } from 'tio-data/data/resources/financial-institution.type';
import type RouterService from 'tio-employee/services/router';

export default class SyfAccountLinkingRouteComponent extends Component {
  @service declare router: RouterService;

  didLink = (institution: FinancialInstitutionModel) => {
    this.router.transitionTo('authenticated.syf.linking-confirmation', institution.legacyId);
  };

  didCancel = () => {
    this.router.transitionTo('authenticated.syf');
  };

  <template>
    <Section>
      <:header>{{t "account_linking.add_account"}}</:header>
      <:body>
      </:body>
    </Section>
  </template>
}
